/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,ButtonModule,PaginatorModule,DropdownModule, PanelModule} from "primeng/primeng";
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import { MamAdminService } from '../../service/mam_service.component';
import { MamVisitorService } from '../../service/mam_visitor_service.component';
import {CommonModule, DatePipe} from "@angular/common";
import {SearchModule} from "../../component/search.component";
import { Visitor } from '../../model/visitor';
import {SelectItem} from "primeng/components/common/api";
import {TranslateServiceForm, TranslatePipeMoudle} from "../../translate";
import { ExDialogModule } from  '../../component/dialog.component';
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {Paginator} from "primeng/components/paginator/paginator";
import { ReservedVisitor } from '../../model/reserved_visitor';
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import {MainPipeMoudle} from "../../pipe/main.pipe";
import * as glob from "../../service/global_url";

@Component({

selector: 'visitor-management',
templateUrl: 'visitor_management.html'
})
export class VisitorManagementComponent implements  OnInit{

  //model
  visitorList : Visitor[] = [];
  detailSelected : Visitor;
  
  // dialog
  detailShow : boolean = false;
  modifyShow : boolean = false;
  modifyForm : FormGroup;
  dialogWidth : number = 700;
  title : string;
  visitorTypeListForModify : SelectItem[];

  // filter
  searchIsTrue : boolean;
  searchKeyword: string;
  searchValue : string;
  searchValueIsDropBox: boolean;
  searchTextfiledIsUse: boolean;
  searchId: number;

  dateIsTrue : boolean = true;
  startDate: string;
  endDate: string;
  excelIsTrue : boolean = true;

  // filter item
  searchIDs: SelectItem[];
  visitorTypeList : SelectItem[];
  deviceStatus : SelectItem[];
  osTypeList : SelectItem[];
  searchValueDropBox : SelectItem[];

  // paging
  listTotalCount: number;
  rowNum: number;
  pageNum: number;
  @ViewChild('paginator') paginator: Paginator;

  // list
  today: Date;

  // global constant flag
  private visitorInfoModifyIsTrue : boolean = glob.visitorInfoModifyIsTrue;

  

  translate:TranslateServiceForm;

  constructor(private service : MamVisitorService, private fb: FormBuilder, private _translate: TranslateServiceForm, private logger : Logger) { 
    this.translate = _translate;

    this.modifyForm = this.fb.group({
      'id' : new FormControl(''),
      'visitorType' : new FormControl(''),
    });

    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LANG_VISITOR_PhoneNumber'), value: 'mobileNumber'});
    // this.searchIDs.push({label: this.translate.instant('LANG_VISITOR_Type'), value: 'visitorType'});
    this.searchIDs.push({label: this.translate.instant('LANG_DEVICE_device'), value: 'osType'});
    this.searchIDs.push({label: this.translate.instant('LANG_DeviceStatus'), value: 'deviceStatus'});
    
    this.visitorTypeList = [];
    this.visitorTypeList.push({label: '---------------', value: ''});
    this.visitorTypeList.push({label: this.translate.instant('LANG_VISITOR_Type_Common'), value: '0'});
    this.visitorTypeList.push({label: this.translate.instant('LANG_VISITOR_Type_Regular'), value: '1'});
    
    this.visitorTypeListForModify = [];
    this.visitorTypeListForModify.push({label: this.translate.instant('LANG_VISITOR_Type_Common'), value: '0'});
    this.visitorTypeListForModify.push({label: this.translate.instant('LANG_VISITOR_Type_Regular'), value: '1'});
    
    this.deviceStatus = [];
    this.deviceStatus.push({label: '---------------', value: ''});
    this.deviceStatus.push({label: this.translate.instant('LANG_PolicyIn'), value: '2'});
    this.deviceStatus.push({label: this.translate.instant('LANG_PolicyOut'), value: '3'});
    // this.deviceStatus.push({label: this.translate.instant('LANG_App_Install')+"("+this.translate.instant('AL_ProfileCreateToNormal')+")", value: 'DEVICE_REGISTOR'});
    // this.deviceStatus.push({label: this.translate.instant('LANG_App_Delete')+"("+this.translate.instant('AL_ProfileDeleteToNormal')+")", value: 'DEVICE_UNREGISTOR'});


    this.osTypeList = [];
    this.osTypeList.push({label: '---------------', value: ''});
    this.osTypeList.push({label: this.translate.instant('LANG_Android'), value: 'ANDROID'});
    this.osTypeList.push({label: this.translate.instant('LANG_iPhone'), value: 'IOS'});
    this.osTypeList.push({label: this.translate.instant('LANG_WindowPhone'), value: 'WINDOWS_OS'});
    this.osTypeList.push({label: this.translate.instant('Lang_DeviceSumOther'), value: 'OTHER'});

    this.rowNum = 10;
    this.pageNum = 0;
    this.getVisitorList();
  }

  ngOnInit(): void {
  }
  
  //event///////////////////////////////////////
  paginate(event) {
    this.logger.debug(event);
    this.rowNum = event.rows;
    this.pageNum = event.page;
    this.getVisitorList();
  }
 
  searchKeywordChange(data) {
    this.logger.debug("data => ", data);
    if (data == 'osType') {
      this.searchValueIsDropBox = true;
      this.searchValueDropBox = this.osTypeList;
      this.searchTextfiledIsUse = false;
    } else if(data == 'visitorType') {
      this.searchValueDropBox = this.visitorTypeList;
      this.searchTextfiledIsUse = false;
      this.searchValueIsDropBox = true;
    } else if(data == 'deviceStatus') {
      this.searchValueIsDropBox = true;
      this.searchValueDropBox = this.deviceStatus;
      this.searchTextfiledIsUse = false;
    } else if(data == 'all' || !data) {
      this.searchTextfiledIsUse = false;
      this.searchValueIsDropBox = false;
    } else {
      this.searchTextfiledIsUse = true;
      this.searchValueIsDropBox = false;
    }
  }
  
  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchKeyword = event.searchId;
    this.searchValue = event.searchText;
    this.startDate = event.sDate;
    this.endDate = event.eDate;
    this.searchId = event.searchId;
//    this.logger.debug(this.searchId)

    if(this.endDate < this.startDate ) {
      alert(this.translate.instant('MESSAGE_LastDate_Less_StartDate'));
      return;
    }
    //this.paginator.changePageToFirst({});
    this.pageNum = 0;
    this.getVisitorList();
  }
  
  doActionPolicyFree(data) {
    this.logger.debug("-- data : " + data.visitorDevice.id);
    this.pushPolicyFree(data.visitorDevice.id);
  }
  
  exportExcel(data) {
    this.logger.debug("excel 다운 : ",data);
    if (data) {
      this.searchIsTrue = data.searchIsTrue;
      this.searchKeyword = data.searchId;
      this.searchValue = data.searchText;
      this.startDate = data.sDate;
      this.endDate = data.eDate;
      this.searchId = data.searchId;  
    }
    this.getVisitorListExcel();
  }

  
  showDetail(data) {
    this.detailShow = true;
    this.dialogWidth = 600;
    this.detailSelected = data;
    this.title = this.translate.instant('LANG_Detail');
  }
  showModify(data) {
    this.modifyShow = true;
    this.dialogWidth = 600;
    this.detailSelected = data;
    this.modifyForm.controls['id'].setValue(data.id);
    this.modifyForm.controls['visitorType'].setValue(data.visitorType);
    this.title = this.translate.instant('LANG_VISITOR_Modify');
  }

  hideDialog(event){
    this.detailShow = false;
    this.modifyShow =false;
  }

  modifyVisitorInfo(value){
    this.logger.debug("value :", value);

    let visitor:Visitor = {
      id : value.id,
      visitorType : value.visitorType,
      device : null
    }
    
    this.updateVisitor(visitor);
  }

  /////////////////////////////////////////////

  getVisitorListExcel() {
    this.logger.debug("download >>");
    this.service.getVisitorListExcel(this.searchKeyword, this.searchValue, this.startDate, this.endDate);
  }

  pushPolicyFree(device_id:number) {
    this.service.pushPolicyFree(device_id).subscribe(
        value => {
          let result = value;
        },
        error => { 
          let result = error.json();
          this.logger.error("-- error : " + error);
          alert(result.message);
        },
        () => {
          alert(this.translate.instant('MESSAGE_Policy_Released'));
          this.getVisitorList();
        }
    )
  }

  getVisitorList(){
    var urlPath = "/visitor";
    this.service.getList(urlPath, this.pageNum, this.rowNum, this.searchKeyword, this.searchValue, this.startDate, this.endDate)
    .subscribe(
      value => {
        if (value != null) {
          this.visitorList = value.data.content;
          this.listTotalCount = value.data.totalElements;
          this.today = new Date();
          this.today.setHours(0,0,0,0);
          this.logger.debug(this.listTotalCount);  
        } else {
          this.visitorList = [];
          this.listTotalCount = 0;
        }
      },
      error => {
        let result = error.json();
        this.logger.error("-- error : " + error);
        alert(result.message);
      },
      () => {}
    );
  }
  updateVisitor(visitor) {
    this.service.updateVisitor(visitor).subscribe(
        value => {
          var result = value;
          this.logger.debug("-- result :", result);
        },
        error => {
          let result = error.json();
          this.logger.error("-- error : " + error);
          alert(result.message);
        },
        () => {
          alert(this.translate.instant('MESSAGE_VISITOR_UpdateSuccess'));
          this.logger.info("-- complate : ");
          this.modifyShow = false;
          this.modifyForm.reset();
          this.getVisitorList();
        }
    )
  }
}
@NgModule({
  imports: [SearchDropBoxModule, DataTableModule,ButtonModule,HttpModule,BrowserModule, CommonModule,PaginatorModule,DropdownModule,FormsModule,SearchModule, ReactiveFormsModule, ExDialogModule, PanelModule, MainPipeMoudle, TranslatePipeMoudle],
  exports: [VisitorManagementComponent],
  declarations: [VisitorManagementComponent],
  providers: [MamAdminService],
})
export class VisitorManagementModule {
}



// WEBPACK FOOTER //
// ./src/app/page/visitor/visitor_management.ts